<template>
    <div style="height: 100%;">
        <template v-if="isLoading">
            <ob-spinner loading-text="Loading..."></ob-spinner>
        </template>
        <template v-else>
            <folder-list :list.sync="I983List" v-if="I983List.length > 0" @formDeleted="onFormDelete" @initiated="fetchData"></folder-list>
            <Fromi983-intro @initiated="fetchData" v-else></Fromi983-intro>
        </template>
    </div>
</template>
<script>
    import FormI983IntroPage from './FormI983/FormI983Intro.vue'
    import FolderList from './FormI983/FolderList.vue'

    export default {
        props: ["consultantDetails","isSupervisor"],
        data() {
            return {
                I983List: [],
                isLoading: true,
                show:false,
                showUpdateTrainingPlanPopup:false
            }
        },
        components: {
             "Fromi983-intro": FormI983IntroPage,
             "folder-list": FolderList
        },
        computed: {
            EmployeeId() {
                  if(this.$route.query.EmployeeId){
                        return this.$route.query.EmployeeId
                  }
                  else
                    return  this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
            },
            IsFinalEvaluationDone() {
                if(this.I983List.length > 0) {
                    let isDone = false;
                    this.I983List.forEach((l) => {
                        if(l.Evaluation && l.Evaluation.IsFinalEvalution === true) {
                            isDone = true;
                        }
                    });

                    return isDone;
                } else {
                    return false;
                }
            }
        },
         watch: {
            EmployeeId(val) {
                if(val != null && val != '')
                {
                   this.fetchData()
                }
            }
        },
        created()
        {
            let interval = setInterval(() => {
                if(this.EmployeeId && this.EmployeeId != '') {
                    clearInterval(interval);
                        this.fetchData();
                }
            }, 500);
            bus.listen("SendI983RefreshSignal", () => {
                this.fetchData('fromSignaR')
            })
        },
        methods:{

            fetchData(v) {
                if(v == 'fromSignaR')
                {
                    this.isLoading = false;
                }
                else{
                  this.isLoading = true;
                }
                var empId = this.EmployeeId
                ajax.get(`/I983/GetI983DetailsList?employeeId=${empId}`, {}, (res) => {
                    if (res.data.State == true) {
                        this.I983List = res.data.resultList;
                        this.isLoading = false;
                    }
                    else
                    {
                        this.I983List = [];
                        this.isLoading = false;
                    }
                    this.ESSEnableDisable(res)
                })
            },

            onFormDelete(id) {
                let index = this.I983List.findIndex(l => l.Id == id);
                if(index != -1) {
                    this.I983List.splice(index, 1);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ESSProfile/FormI983.vue